export const resultsPageTabMessagesEn = {
  draftTitle: 'Cohort not processed',
  draftMessage: 'Process the cohort to view attrition, characteristics, and subjects.',
  processingTitle: 'Cohort processing in progress',
  processingMessage:
    'Attrition, characteristics, and subjects will be available once processing is complete.',
  processedNoDataTitle: 'No subjects in cohort',
  processedNoDataMessage:
    'Add subjects to the cohort to view attrition, characteristics, and subjects.',
  errorTitle: 'Error processing cohort',
  errorMessage:
    'An error occurred while processing the cohort. Please review and re-process the cohort.',
};
